import { render } from "./ThePractice.vue?vue&type=template&id=ebb0f648&scoped=true"
import script from "./ThePractice.vue?vue&type=script&lang=js"
export * from "./ThePractice.vue?vue&type=script&lang=js"

import "./ThePractice.vue?vue&type=style&index=0&id=ebb0f648&scoped=true&lang=css"

import exportComponent from "/Users/alialsaady/Documents/repos/tandzorggestel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb0f648"]])

export default __exports__